import React, { useMemo } from "react";
import * as d3 from "d3";
import { useSelector } from "react-redux";
import { calculatePercentage } from "../../SysGuard/sysGuardConstants";
import "./VennLegend.scss";

const PRIMARY_COLORS = [
  "#8B5CF6",
  "#F97316",
  "#06B6D4",
  "#EF4444",
  "#10B981",
  "#F59E0B",
  "#EC4899",
  "#3B82F6",
  "#84CC16",
  "#8B5A2B",
  "#6366F1",
  "#14B8A6",
];

const getColors = (count) => {
  let colors = [...PRIMARY_COLORS];

  if (count > PRIMARY_COLORS.length) {
    const d3Colors = [
      ...new Set([
        ...d3.schemeCategory10,
        ...d3.schemeSet1,
        ...d3.schemeSet2,
        ...d3.schemeSet3,
        ...d3.schemeDark2,
        ...d3.schemeAccent,
      ]),
    ];

    colors = colors.concat(
      d3Colors.slice(0, count - PRIMARY_COLORS.length)
    );
  }

  return colors;
};

const VennLegend = () => {
  const rolesData = useSelector(
    (state) => state.DataguardReducer.rolesData
  );

  const topRoles = useMemo(() => {
    if (!rolesData?.combinations?.length) return [];

    const totalUsers = rolesData.combinations
      .filter((item) => item.sets.length === 1)
      .reduce((sum, item) => sum + item.size, 0);

    return rolesData.combinations
      .filter((item) => item.sets.length === 1)
      .map((item) => ({
        ...item,
        percentage: calculatePercentage(item.size, totalUsers),
      }))
      .sort((a, b) => b.size - a.size)
      .slice(0, 3);
  }, [rolesData]);

  if (!topRoles.length) return null;

  const colors = getColors(topRoles.length);

  return (
    <div className="venn-legend-container">
      <h3
        className="ico-label"
        title="Top 3 Roles with Most Users"
      >
        Top 3 Roles
      </h3>

      <div className="venn-legend-items">
        {topRoles.map((role, index) => (
          <div
            key={role.label || role.tooltip || index}
            className="venn-legend-item"
          >
            <div
              className="venn-legend-circle"
              style={{ backgroundColor: colors[index] }}
            />

            <div className="venn-legend-text">
              <span className="venn-role-name" title={role.label}>
                {role.label || role.tooltip || "Unknown"}
              </span>

              <span
                className="venn-role-percentage"
                title={`${role.size} users`}
              >
                ({role.percentage}%)
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VennLegend;